/*  Inspired by:
https://medium.com/@hridoymahmud/solving-image-loading-and-error-handling-issues-in-react-with-a-custom-image-component-b6c5d0184f96
https://dev.to/eidellev/handling-broken-images-in-react-4oo2  */

import {useState} from "react";

export default function ImgComp (props: any) {

    const [isImgBroken, setIsImgBroken] = useState(false);

    if (isImgBroken) {
        let newProps = {...props}
        newProps["src"] = "https://icefeeds.com/no_image_placeholder_280x280.png"
        return <img {...newProps}  alt="" />
    }

    return <img onError={() => setIsImgBroken(true)} {...props} alt="" />

}
